exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".widget-link.solid-gauge .widget-icon {\n  background-image: url(\"/content/plugin-solid-gauge/icon.svg\") !important;\n  opacity: 1 !important; }\n", ""]);

